export const ActionTypes = {
  LOADING: "GET_AREA_STATUSES_LOADING",
  ERROR: "GET_AREA_STATUSES_ERROR",
  SUCCESS: "GET_AREA_STATUSES_SUCCESS"
};
